import fuelSurchargesCreateComponent from './fuel_surcharges.create.component';

let fuelSurchargesCreateModule = angular.module('fuelsurchargescreate', [
])

  .component('fuelsurchargescreate', fuelSurchargesCreateComponent)

  .name;

export default fuelSurchargesCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/fuel_surcharges/create/index.js